import { render } from "./patients-cancelled.vue?vue&type=template&id=207d882c"
import script from "./patients-cancelled.vue?vue&type=script&lang=js"
export * from "./patients-cancelled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__